import React from "react";

/**
 * Simple hidden input field for storing values (e.g. UTM params, package) without displaying them.
 * Values can be pre-populated from URL parameters via config.data.
 */
const SimpleHidden = ({ register, id, field }) => {
	const htmlId = field?.id || id;
	return <input type="hidden" id={htmlId} {...register(id)} />;
};

export default SimpleHidden;

